import React from "react";
import { Field, reduxForm } from "redux-form";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../Components/Forms/renders";
import Multiselect from "../../../Components/Forms/multiselect";
import InputRange from "../../../Components/Forms/range";
class LogboekFormWebsite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      inschrijving: false,
    };
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <Field
            name="naam"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Naam van de activiteit"
          />
          <Field
            name="beschrijving"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderTextField}
            label="Korte beschrijving van de activiteit"
          />
          <Field
            className="form"
            autoFocus={true}
            name="duur"
            validate={required({ msg: "Type item is verplicht" })}
            label="Duur van de activiteit"
            component={InputRange}
          />
          <Field
            className="form"
            autoFocus={true}
            name="doelgroep"
            validate={required({ msg: "Type item is verplicht" })}
            label="Doelgroep"
            component={Multiselect}
            options={["Kinderen 0-4", "Kinderen 4-8", "Kinderen 8-12", "Jeugd 12-15", "16+", "Volwassenen", "Gezinnen", "Senioren"]}
          />
          <Field
            className="form"
            type="number"
            autoFocus={true}
            name="mindeelnemers"
            validate={required({ msg: "Type item is verplicht" })}
            label="Minimaal aantal deelnemers"
            component={renderField}
          />
          <Field
            className="form"
            autoFocus={true}
            name="categorie"
            validate={required({ msg: "Type item is verplicht" })}
            label="Categorie"
            component={Multiselect}
            options={["Creativiteit", "Spel", "Sport", "Tochten", "Thema", " Show/amusement", "Theater", "Minidisco", "Kerkdienst", "Alex en Sammy"]}
          />
          <Field
            className="form"
            autoFocus={true}
            name="plaats"
            validate={required({ msg: "Type item is verplicht" })}
            label="Plaats van de activiteit"
            component={Multiselect}
            options={["Bos", "Zwembad", "Gehele park", "Recreatiezaal", " Restaurant", "Sportveld", "Strand", "Overige"]}
          />
          <Field
            className="form"
            autoFocus={true}
            name="slechtweer"
            validate={required({ msg: "Type item is verplicht" })}
            label="Slechtweer activiteit"
            component={renderselect}
            options={["Ja", "Nee"]}
          />

          <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg submit-bt" name="next" value="Volgende stap" />
        </div>
      </form>
    );
  }
}
LogboekFormWebsite = reduxForm({
  form: "formactiviteit", // a unique identifier for this form
  enableReinitialize: true,
})(LogboekFormWebsite);

export default LogboekFormWebsite;
